import axios from 'axios';
import { apiUrl } from './api';

export const logout = async () => {
  const token = localStorage.getItem("token");

  try {
    await axios.post(apiUrl('/auth/token/logout/'), null, {
      headers: {
        Authorization: `Token ${token}`,
      },
    });
  } catch (error) {
    console.warn("No se pudo cerrar sesión desde el backend", error);
  }

  localStorage.removeItem("token");
  localStorage.setItem("logout_success", "true");  // ⚠️ Flag temporal
};
